import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ChevronDownIcon, PhoneIcon, XIcon } from 'lucide-react';
import { mainNav, megaGroups } from '../../data/navigation';
import { BOOKING_URL, SITE } from '../../data/site';
interface MobileNavProps {
  onClose: () => void;
}
export function MobileNav({
  onClose
}: MobileNavProps) {
  const [coursesOpen, setCoursesOpen] = useState(false);
  return <motion.div role="dialog" aria-modal="true" aria-label="Site menu" initial={{
    opacity: 0,
    x: 24
  }} animate={{
    opacity: 1,
    x: 0
  }} exit={{
    opacity: 0,
    x: 24
  }} transition={{
    duration: 0.22,
    ease: [0.23, 1, 0.32, 1]
  }} className="fixed inset-0 z-[70] flex flex-col overflow-y-auto bg-ink" data-id="element-415" data-mp="3tc9ki8k595it">
      <div className="gutter flex h-[var(--header-h)] shrink-0 items-center justify-between border-b border-white/10" data-id="element-416" data-mp="1hjtfiigp7vgd">
        <span className="font-display text-lg font-semibold uppercase tracking-wider text-white" data-id="element-417" data-mp="1ckq9auozfj6t">Menu</span>
        <button type="button" onClick={onClose} className="flex h-11 w-11 items-center justify-center rounded-sm text-white" aria-label="Close menu" data-id="element-418" data-mp="1d6vzq77av8n3">
          <XIcon className="h-6 w-6" aria-hidden="true" data-id="element-419" data-mp="1m8de9l52729o" />
        </button>
      </div>
      <nav className="gutter flex-1 py-4" aria-label="Mobile" data-id="element-420" data-mp="1r76rrdkcit9u">
        <button type="button" onClick={() => setCoursesOpen(v => !v)} aria-expanded={coursesOpen} className="flex w-full items-center justify-between border-b border-white/10 py-4 font-display text-2xl font-semibold uppercase text-white" data-id="element-421" data-mp="1r6op9z73bith">
          Courses
          <ChevronDownIcon className={`h-6 w-6 transition-transform duration-200 ${coursesOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-422" data-mp="13gb5evynsq9z" />
        </button>
        {coursesOpen && <div className="grid gap-6 border-b border-white/10 py-5 sm:grid-cols-2" data-id="element-423" data-mp="asfanwsnh8fu">
            {megaGroups.map(g => <div key={g.title} data-id="element-424" data-mp="fpylsnu1x53k">
                <p className="text-xs font-semibold uppercase tracking-[0.12em] text-chrome-500" data-id="element-425" data-mp="7qtzodv9aeaa">{g.title}</p>
                <ul className="mt-2 space-y-1" data-id="element-426" data-mp="3qjw17uxrzyl">
                  {g.links.map(l => <li key={l.label} data-id="element-427" data-mp="hholjh4lbbv7">
                      <Link to={l.to} onClick={onClose} className="block py-1.5 text-chrome-100" data-id="element-428" data-mp="hgncfi74wzg4">
                        {l.label}
                      </Link>
                    </li>)}
                </ul>
              </div>)}
            <Link to="/courses" onClick={onClose} className="font-semibold text-white underline underline-offset-4" data-id="element-429" data-mp="3gws9r28vdf3a">
              View all courses
            </Link>
          </div>}
        <ul data-id="element-430" data-mp="3px8bo79yse61">
          {mainNav.map(item => <li key={item.to} data-id="element-431" data-mp="3pvdt2zm60y54">
              <Link to={item.to} onClick={onClose} className="block border-b border-white/10 py-4 font-display text-2xl font-semibold uppercase text-white" data-id="element-432" data-mp="1a5u889f7faxo">
                {item.label}
              </Link>
            </li>)}
        </ul>
      </nav>
      <div className="gutter grid shrink-0 grid-cols-2 gap-3 border-t border-white/10 py-5" data-id="element-433" data-mp="2n2t3n9mzujtc">
        <a href={SITE.phoneHref} className="flex h-12 items-center justify-center gap-2 rounded-[3px] border border-white/50 font-display text-sm font-semibold uppercase tracking-wider text-white" data-id="element-434" data-mp="2s48ob0l9eob7">
          <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-435" data-mp="2j3kcmcjc901h" /> Call
        </a>
        <a href={BOOKING_URL} className="flex h-12 items-center justify-center rounded-[3px] bg-accent font-display text-sm font-semibold uppercase tracking-wider text-white" data-id="element-436" data-mp="36s3kiqyh7at1">
          Book a Class
        </a>
      </div>
    </motion.div>;
}